export { default } from "./src/global-footer";
